import { Component, OnInit } from '@angular/core'
import { Auth } from '@angular/fire/auth'
import { addDoc, collection, doc, DocumentData, Firestore, getDocs, orderBy, query, QuerySnapshot, updateDoc } from '@angular/fire/firestore'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { MatSnackBar } from '@angular/material/snack-bar'
import { firebaseToDate } from 'src/app/service/time-util'
import { TrainingType } from 'src/domain/training'

@Component({
    templateUrl: './training-type.component.html',
    styleUrls: ['./training-type.component.scss'],
    standalone: false
})
export class TrainingTypeComponent implements OnInit {
  constructor(private store: Firestore, private auth: Auth, private snack: MatSnackBar) {}

  trainingTypes: TrainingType[] = []

  newType = new UntypedFormGroup({
    hu: new UntypedFormControl(null, [Validators.required]),
    en: new UntypedFormControl(null),
  })

  ngOnInit(): void {
    this.refresh()
  }

  private refresh() {
    this.clearForm()
    getDocs(query(collection(this.store, 'training-types'), orderBy('hu'))).then((snap: QuerySnapshot<DocumentData>) => {
      this.trainingTypes = snap.docs
        .map((d) => {
          const data = d.data() as TrainingType
          return {
            ...data,
            id: d.id,
            createdAt: firebaseToDate(data.createdAt),
            deleted: firebaseToDate(data.deleted),
          } as TrainingType
        })
        .filter((d) => d.deleted == null)
    })
  }

  clearForm() {
    this.newType.reset()
  }

  async save() {
    if (this.newType.valid) {
      const value = this.newType.value
      try {
        const createdBy = this.auth.currentUser.email
        await addDoc(collection(this.store, 'training-types'), {
          hu: value.hu,
          en: value.en || null,
          createdAt: new Date(),
          createdBy,
        })
        this.snack.open(`Sikeres mentés ${value.hu}`, 'Rendben', { duration: 2000 })
        this.refresh()
      } catch (e) {
        console.error(e)
        this.snack.open('Nem sikerült a mentés', 'Az baj')
      }
    }
  }

  async delete(training: TrainingType) {
    if (training.id && confirm(`Biztos törölni szeretné a '${training.hu}' gyakorlatot?`)) {
      try {
        await updateDoc(doc(this.store, 'training-types', training.id), {
          deleted: new Date(),
        } as Partial<TrainingType>)
        this.snack.open('Gyakorlat törölve', 'Ok', { duration: 2000 })
        this.refresh()
      } catch (e) {
        console.error(e)
        this.snack.open(`Nem sikerült a gyakorlat törlése`, 'Francba')
      }
    }
  }
}
